.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

/* The two numbers side by side: the decision is a comparison, so the layout
   should be one too. */
.numbers {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-3);
}

.stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: var(--space-3);
  background: var(--bg-sunken);
  border-radius: var(--radius);
}

.statLabel {
  font-size: var(--text-xs);
  font-weight: var(--weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}

.statValue {
  font-size: var(--text-xl);
  font-weight: var(--weight-bold);
  font-variant-numeric: tabular-nums;
}

.statMeta {
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.error {
  margin: 0;
  font-size: var(--text-sm);
  color: var(--danger);
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  width: 100%;
}

/* Pushes Cancel/Publish right when "Use real rating" is absent. */
.footerRight {
  display: flex;
  gap: var(--space-2);
  margin-left: auto;
}
